import { SerializedError } from "@reduxjs/toolkit";
import { FetchBaseQueryError } from "@reduxjs/toolkit/dist/query";
import { useEffect } from "react";
import { toast } from "../lib/toast";
import { ApiErrorType } from "../types";

export default function useError(
  isError: boolean,
  error: FetchBaseQueryError | SerializedError | undefined,
  message: string
) {
  useEffect(() => {
    if (isError && error) {
      const err = error as ApiErrorType;
      const msg = err.data?.message;
      toast("error", msg && typeof msg === "string" ? msg : message);
    }
  }, [error, isError, message]);

  return undefined;
}
